export default function validateFormTags(tags) {
  // If tags only contain one element then it means only the user's email was added.
  // If so then return an error.
  return tags.length < 2;
}
